export const STEP_1 = '1';
export const STEP_2 = '2';
export const STEP_3 = '3';
export const STEP_4 = '4';
export const STEP_5 = '5';

export const COTTON_COMPOSITION_VALUE = '115';
export const BLEND_COMPOSITION_VALUE = '116';

export const DENIM_STEPS: any = {
  [STEP_1]: {
    prev: null,
    next: STEP_2,
    keys: ['denimComposition', 'minStretch', 'maxStretch', 'isComposition', 'compositions'],
    title: 'Composition',
  },
  [STEP_2]: {
    prev: STEP_1,
    next: STEP_3,
    keys: ['weightSpecification', 'weightUnitId', 'denimWeight'],
    title: 'Weight',
  },
  [STEP_3]: {
    prev: STEP_2,
    next: STEP_4,
    keys: ['minWidth', 'maxWidth', 'cuttableWidth', 'warpCount', 'weftCount', 'warpDenier', 'weftDenier'],
    title: 'Quality specifications',
  },
  [STEP_4]: {
    prev: STEP_3,
    next: STEP_5,
    keys: ['weavePattern', 'denimColor'],
    title: 'Denim details',
  },
  [STEP_5]: {
    prev: STEP_4,
    next: null,
    keys: ['creditPeriod'],
    title: 'Payment type',
  }
};
export const COMPOSITION_TYPES = (isRayon: boolean) => {
  return [
    {
      label: `100% ${isRayon ? 'Rayon' : 'Cotton'}`,
      value: '115',
    },
    {
      label: 'Blend',
      value: '116',
    },
  ];
};
export const WEIGHT_TABS = [
  {
    title: 'Before wash',
    value: 1,
  },
  {
    title: 'After wash',
    value: 2,
  },
];
export const WEIGHT_UNITS = [
  {
    name: 'GSM',
    id: 10,
  },
  {
    name: 'Ounce',
    id: 12,
  },
];
export const WEIGHT_VALUES : { [key: number]: string } ={
  10 : 'gsm',
  12 : 'oz'
}

export const WEIGHT_VALUES_CAP : { [key: number]: string } ={
  10 : 'GSM',
  12 : 'Ounce'
}

export const WEIGHT_VALUES_REVERSE:{[key: string]: number}={
  'GSM' : 10,
  'Ounce' : 12,
}
export const WEAVE_PATTERN: { [key: number]: string } = {
  1: '3/1',
  2: '2/1',
  3: 'Satin',
  4: 'Dobby',
  5: 'Knit',
  6: '3/1 RHT',
  7: '3/1 LHT',
  8: '2/1 RHT',
  9: '2/1 LHT',
};
export const DENIM_COLOR_TYPES = [
  {
    label: 'Indigo',
    value: '1',
  },
  {
    label: 'Blue',
    value: '2',
  },
  {
    label: 'Black',
    value: '3',
  },
  {
    label: 'IBST',
    value: '4',
  },
  {
    label: 'Ecru',
    value: '5',
  },
];
